import notify from "@/lib/notifications";
import router from "@/routes";

// interceptors to catch network error
const errorInterceptor = error => {
  // @TODO intercept Authentication errors and logout user
  // ========================>

  if (
    error &&
    error.response &&
    error.response.status &&
    error.response.status === 400
  ) {
    console.error(error.response.status, error.message);
    notify.warn(
      "Nothing to display",
      `${
        error.response.data.detail
          ? error.response.data.detail
          : "Data Not Found"
      }`
    );
  } else if (
    error.response &&
    error.response.status &&
    error.response.status === 401
  ) {
    notify.warn(
      "Please login again",
      `${
        error.response.data.detail
          ? error.response.data.detail
          : "Session Expired"
      }`
    );
    localStorage.removeItem("token");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    router.push("/auth");
  } else {
    if (error.response) {
      console.error(error.response.status, error.message);
    }
    notify.warn("Oops! Something went wrong!");
  }
  return Promise.reject(error);
};

export default errorInterceptor;
